/**
 * Filas «empresa + botón Permisos» de la pantalla de Usuarios (spec 2026-10-07
 * §4). Una por empresa elegida en «Clientes vinculados». El botón abre el mismo
 * panel de Clientes (una sola matriz) y solo se activa si el usuario YA está
 * vinculado a la empresa (addUser ya sembró su matriz por rol) y quien mira
 * tiene más rango que él (lib/target_rank.canShowPermissions). Módulo puro.
 */
import { linkedCustomerIds } from './customer_links';
import { canShowPermissions } from './target_rank';

export const HINT_NO_USER = 'Disponible después de crear el usuario.';
export const HINT_NOT_LINKED = 'Aún no está vinculado a esta empresa: guarde para vincularlo y luego ajuste sus permisos aquí.';
export const HINT_NO_RANK = 'Su rango no le permite ajustar los permisos de este usuario.';

export const companyRows = ({ links, customers, uid, viewerRole, targetRole }) => {
  const list = Array.isArray(customers) ? customers : [];
  const byCid = new Map(list.map((c) => [c.cid, c]));
  const linked = new Set(uid ? linkedCustomerIds(list, uid) : []);
  const allowed = canShowPermissions(viewerRole, targetRole);
  return [...new Set(Array.isArray(links) ? links : [])]
    .filter((cid) => byCid.has(cid))
    .map((cid) => {
      const isLinked = linked.has(cid);
      let hint = null;
      if (!uid) hint = HINT_NO_USER;
      else if (!isLinked) hint = HINT_NOT_LINKED;
      else if (!allowed) hint = HINT_NO_RANK;
      return { cid, name: byCid.get(cid).name || cid, linked: isLinked, canOpen: !!uid && isLinked && allowed, hint };
    });
};

export default companyRows;
